import { render, staticRenderFns } from "./CustomerDetailTab.vue?vue&type=template&id=e4aacedc&scoped=true"
import script from "./CustomerDetailTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailTab.vue?vue&type=style&index=0&id=e4aacedc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4aacedc",
  null
  
)

export default component.exports